import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { getDefaultHomePath } from '@/constants/modules';
import { userCanAccessPainelOficina } from '@/lib/painelOficina';

interface PainelOficinaRouteProps {
  children: React.ReactNode;
}

/** Admin / gestor / operador com módulo Painel Oficina em `allowedModules`. */
export const PainelOficinaRoute: React.FC<PainelOficinaRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
          <p>Carregando…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!userCanAccessPainelOficina(user.role, user.allowedModules)) {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  return <>{children}</>;
};
